import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { useSafeAnimation } from '../ui/SafeMotion';

export function CTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  // SSR-safe animation props
  const anim = useSafeAnimation(
    { opacity: 0, y: 20 },
    { opacity: 1, y: 0 },
    isInView
  );

  return (
    <section ref={ref} className="py-20 bg-gradient-to-br from-eco-green-800 to-eco-green-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={anim.initial}
          animate={anim.animate}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">
            Need a Reliable Waste Management Partner?
          </h2>
          <p className="text-eco-green-200 text-lg mb-8">
            Get a customized waste recovery plan for your facility. Let's discuss how we can help you achieve your sustainability goals.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact?quote=true"
              className="px-8 py-4 bg-white text-eco-green-800 font-semibold rounded-xl hover:bg-eco-green-50 transition-colors"
            >
              Get a Quote
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 border border-white/30 text-white font-semibold rounded-xl hover:bg-white/10 transition-colors"
            >
              Talk to Our Team
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
